import { render, staticRenderFns } from "./ResizableSidebar.vue?vue&type=template&id=206c82c9&"
import script from "./ResizableSidebar.vue?vue&type=script&lang=js&"
export * from "./ResizableSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports